import maintenance_flag from "../../../Assets/Flags/maintenance_flag.svg";
import { ICardHUProps } from "../../../Interfaces";
import { formatter } from "../../../Utils";
import { Container, Flag, Price, State, StateContainer } from "./style";

interface IMaintenanceInfos {
  isReserved: boolean;
}

const MaintenanceInfos = ({
  data,
  isReserved,
}: ICardHUProps & IMaintenanceInfos) => {
  const { price, state } = data;

  return (
    <Container>
      <StateContainer>
        <Flag src={maintenance_flag} />
        <State state={state} isReserved={isReserved}>
          manutenção
        </State>
      </StateContainer>
      <Price>{formatter.format(price)}</Price>
    </Container>
  );
};
export default MaintenanceInfos;
